module.exports = __webpack_public_path__ + "static/media/no-profile.313b1307.svg";